import {Box, Tab, Tabs, Button} from '@mui/material';
import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

type Props = {
  activePage: number;
  // eslint-disable-next-line no-unused-vars
  navigateStage: (index: number) => void;
  navItems: {label: string}[];
  handleQuite: Function;
};

export default function NavMenu(props: Props) {
  const {activePage, navigateStage, navItems, handleQuite} = props;

  return (
    <header>
      <nav style={styles.container}>
        <Box style={styles.boxContainer}>
          <Box sx={styles.boxStyle}>
            <Button
              variant="text"
              startIcon={<ArrowBackIcon />}
              color="inherit"
              onClick={() => handleQuite()}>
              Back to Dashboard
            </Button>
            <Tabs
              centered
              value={activePage}
              // onChange={handleChange}
              aria-label="basic tabs example">
              {navItems.map((item, index) => (
                <Tab
                  disabled={activePage + 1 <= index}
                  style={styles.tabStyle}
                  key={index}
                  label={item.label}
                  onClick={() => navigateStage(index)}
                />
              ))}
            </Tabs>
          </Box>
        </Box>
      </nav>
    </header>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  boxContainer: {
    flexDirection: 'row',
    height: 120,
    justifyContent: 'center',
    alignItems: 'flex-end',
    width: '80%',
  },
  boxStyle: {borderBottom: 1, borderColor: 'divider'},
  tabStyle: {width: '100%'},
};
